module.exports = {
	"tools": [
		{
			"title": "Quote request tool",
			"description": "Need to buy or sell a bond but don’t see a live bid or offer for the CUSIP? Use the quote request tool to submit a bid (sell) or offer (buy) quote request, and we’ll get a price quote from our dealer network.",
			"img": "resources/images/quote-request-tool.png",
			"nav": "goto",
			"navArg": {
				"view": "tools.get-a-bond-quote",
				"actionSubset": "WF",
				"action": "W",
				"from": "tools-and-resources"
			}
		},
		{
			"title": "Bond ladder builder",
			"description": "Create a custom laddered portfolio, designed to reduce interest rate risk exposure and generate predictable income.",
			"img": "resources/images/bond-ladder-builder.png",
			"nav": "goto",
			"navArg": "bond-ladder-builder"
		},
		{
			"title": "Treasury auctions",
			"description": "See the latest Treasury auction schedule and place orders.",
			"img": "resources/images/treasury-auctions@3x.png",
			"nav": "goto",
			"navArg": {
				"view": "tools.treasury-auctions",
				"from": "tools-and-resources"
			}
		},
		{
			"title": "Advanced bond screener",
			"description": "Choose from a comprehensive range of criteria to customize your search.",
			"img": "resources/images/advanced-bond-screener.png",
			"nav": "goto",
			"navArg": "advanced-screener"
		},
		{
			"title": "Fixed income portfolio report",
			"description": "View our bond portfolio report with analysis on expected cash flows, maturity and duration exposure, credit quality distribution, and more.",
			"img": "resources/images/fixed-income-portfolio-report@3x.png",
			"nav": "goto",
			"navArg": "portfolio-report"
		},
		{
			"title": "Tax-equivalent yields calculator",
			"description": "Make an after-tax comparison of taxable and tax-exempt bonds. Determine the taxable equivalent yield required of a taxable bond to provide an equal return to a tax-free municipal bond.",
			"img": "resources/images/tax-equivalent-bond-yields-calculator@3x.png",
			"nav": "tey-calculator",
			"tag": "button",
			"navArg": {
				"isReset": true
			}
		},
		{
			"title": "Price/Yield calculator",
			"description": "Calculate the estimated price or yield of a bond and the potential cash flow based on investment quantity.",
			"img": "resources/images/price-yield-calculator.png",
			"nav": "calculator",
			"navArg": {
				"from": "tools-and-resources"
			}
		},
		{
			"title": "Sell order ticket",
			"description": "Need to sell a current bond holding? Use the sell order ticket to liquidate a position. If no live bid is available, submit a bid (sell) quote request, and we'll get a price quote from our dealer network.",
			"img": "resources/images/sell-order-ticket.png",
			"nav": "goto",
			"navArg": {
				"view": "sell-your-bond",
				"from": "tools-and-resources"
			}
		}
	],
	"resources": [
		{
			"title": "Municipal news search",
			"description": "Find relevant news for the municipal market, and monitor trending news articles related to your holdings.",
			"nav": "goto",
			"navArg": "municipals/municipal-market-news"
		},
		{
			"title": "Tradeweb Market Transparency Report",
			"description": "See Tradeweb’s monthly guide with insights on retail fixed income market trends, trade volumes, issuer activity, and more.",
			"nav": "open",
			"navArg": {
				"url": "https://www.bonddesk.com/static/etrade/Market_Transparency.pdf",
				"name": "_blank"
			}
		},
		{
			"title": "Whitepaper: FINRA Smart Bond Investing",
			"description": "Read FINRA’s guide to bond investing to learn more about the basics, types of bonds, and different investment strategies.",
			"nav": "open",
			"navArg": {
				"url": "https://www.bonddesk.com/etrade/smart_bond_investing.pdf",
				"name": "_blank"
			}
		},
		{
			"title": "Article: Understanding brokered CDs",
			"description": "Learn about the features and benefits of brokered certificates of deposit (CDs), compared to traditional bank CDs.",
			"nav": "open",
			"navArg": {
				"url": "https://us.etrade.com/knowledge/library/bonds-cds/understanding-brokered-cds"
			}
		},
		{
			"title": "Article: The basics of bond ladders",
			"description": "Learn the benefits of this simple investment strategy and discover how you can create a bond ladder designed around your goals.",
			"nav": "open",
			"navArg": {
				"url": "https://us.etrade.com/knowledge/library/bonds-cds/bond-ladders"
			}
		},
		{
			"title": "Article: Types of bonds",
			"description": "Explore the various types of bonds and learn which may be best suited for your portfolio.",
			"nav": "open",
			"navArg": {
				"url": "https://us.etrade.com/knowledge/library/bonds-cds/types-of-bonds"
			}
		},
		{
			"title": "Article: What is a bond?",
			"description": "Learn the basics of bonds, why investors include them in portfolios, and how to get started investing in bonds at E*TRADE.",
			"nav": "open",
			"navArg": {
				"url": "https://us.etrade.com/knowledge/library/bonds-cds/what-is-a-bond"
			}
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/tools-and-resources/tools-and-resources.json
// module id = 1832
// module chunks = 0